import React, { useState } from "react";

const selectoptions = [
  {
    id: "formgroup_320_option_WithBoxAndPapers",
    value: "WithBoxAndPapers",
    name: "scopeOfDelivery",
    alt: "Watch with original box and original papers",
    imgSrc: "https://aleeha-test.s3.ap-southeast-1.amazonaws.com/wl-1.png",
    label: "Original box and original papers",
  },
  {
    id: "formgroup_320_option_WithBox",
    value: "WithBox",
    name: "scopeOfDelivery",
    alt: "Watch with original box",
    imgSrc: "https://aleeha-test.s3.ap-southeast-1.amazonaws.com/wl-2.png",
    label: "Original box",
  },
  {
    id: "formgroup_320_option_WithPapers",
    value: "WithPapers",
    name: "scopeOfDelivery",
    alt: "Watch with original papers",
    imgSrc: "https://aleeha-test.s3.ap-southeast-1.amazonaws.com/wl-3.png",
    label: "Original papers",
  },
  {
    id: "formgroup_320_option_WatchOnly",
    value: "WatchOnly",
    name: "scopeOfDelivery",
    alt: "Watch only",
    imgSrc: "https://aleeha-test.s3.ap-southeast-1.amazonaws.com/wl-4.png",
    label: "No further accessories",
  },
];

const Step3 = ({ selected, setSelected }) => {
  return (
    <section className="">
      <h1 className="lg:text-4xl md:text-3xl sm:text-xl mb-8">
        What comes with your watch?
      </h1>

      <div className="grid grid-cols-2 gap-4">
        {selectoptions?.map((option, index) => {
          return (
            <div
              onClick={() => setSelected(index)}
              className={`rounded-lg p-6 bg-white cursor-pointer border border-primary hover:border-secondary ${
                selected === index && "border-secondary"
              }`}
            >
              <img
                src={option?.imgSrc}
                height={100}
                width={100}
                className="rounded"
                alt=""
              />
              <p className="text-[14px] font-medium mt-4">{option?.label}</p>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default Step3;
